"use strict";
var React = require("react");
var clone = require("clone");
var InventoryStore = require("../../../stores/InventoryStore");
var InventoryActions = require("../../../actions/InventoryActions");
var Button = require("react-bootstrap").Button;
var _ = require("underscore");

var ImportTab = React.createClass({
    getInitialState: function() {
        var newState = {
            focus: ""
        };
        var importResponse = InventoryStore.getState().importResponse;
        newState["importData"] = importResponse;
        return newState;
    },
    componentDidMount() {
        InventoryStore.listen(this.onChange);
    },
    componentWillUnmount() {
        InventoryStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.getInitialState());
    },
    handleSubmit(e) {
        e.preventDefault();
    },
    uploadFile(e) {
        var form = document.getElementById("excel");
        var myData = new FormData(form);
        var file = this.refs.importFile.value;
        if(file){
            InventoryActions.importItems(myData);
        } else {
            alert('Engin skrá var valin.');
        }
    },
    mapRows(item, key) {
        var departments = this.state.importData.need_to_create.departments;
        var locations = this.state.importData.need_to_create.locations;
        var types = this.state.importData.need_to_create.types;
        return (
            <tr className="settings-table-row">
                <td className="settings-table-column">
                    <span key={departments[key]+"-"+key}>{departments[key]}</span>
                </td>
                <td className="settings-table-column">
                    <span key={locations[key]+"-"+key}>{locations[key]}</span>
                </td>
                <td className="settings-table-column">
                    <span key={types[key]+"-"+key}>{types[key]}</span>
                </td>
            </tr>
        )
    },
    displayList(object, title) {
        var pivotArray = [];
        for (var element in object) {
            if (object[element].length > pivotArray.length) {
                pivotArray = object[element]
            }
        }
        return (
            <div>
                <h4>{title}</h4>
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <td className="settings-table-column column-title">Deildir</td>
                                <td className="settings-table-column column-title">Staðsetningar</td>
                                <td className="settings-table-column column-title">Tegundir</td>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(pivotArray, this.mapRows)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    },
    mapList(item, key) {
        return (
            <span key={item+"-"+key}>{item}</span>
        );
    },
    toggleList(name) {
        var newName = name;
        if (this.state.focus === name) {
            newName = "";
        }
        this.setState({focus: newName});
    },
    render() {
        var duplicate_names = this.state.importData.duplicate_names;
        var showWarning = false;
        for (var element in duplicate_names) {
            if (duplicate_names[element].length > 0) {
                showWarning = true;
            }
        }
        var exists_but_no_access = this.state.importData.exists_but_no_access;
        for (var element in exists_but_no_access) {
            if (exists_but_no_access[element].length > 0) {
                showWarning = true;
            }
        }
        var need_to_create = this.state.importData.need_to_create;
        for (var element in need_to_create) {
            if (need_to_create[element].length > 0) {
                showWarning = true;
            }
        }

        return (
            <div className="row">
                <div className="settings-header col-xs-12">
                    <h3>Innflutningur gagna</h3>
                </div>
                <div className="settings-body col-xs-12">
                    <div>
                        <p>Hægt er að flytja inn gögn með því að fylla út Excel skjal (<a href="/docs/template.xlsx" target="_blank">sem sækja má með því að smella hér</a>) og hlaða því inn í formið hér að neðan.</p>
                    </div>
                    <div className="well well-lg">
                        <form id="excel" onSubmit={this.handleSubmit} encType="multipart/form-data">
                            <div className="form-group">
                                <label htmlFor="file">Veldu skrá</label>
                                <input ref="importFile" name="file" type="file" id="file" />
                                <small className="help-block">Veldu skrá til að hlaða inn og smelltu á hnappinn hér að neðan til að hefja innlestur</small>
                            </div>
                            <button type="button" className="btn btn-flat btn-blue" onClick={this.uploadFile}>Hlaða inn</button>
                        </form>
                    </div>
                    {showWarning === true &&
                        <div className="warning-container">
                            <strong className="warning title">
                                Sjálfvirkur innflutningur mistókst.
                            </strong>
                        </div>
                    }
                    {duplicate_names.departments.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi deildir fundust oftar en einu sinni í kerfinu.
                                Vinsamlegast breyttu nöfnum þeirra í skjalinu í viðeigandi UUID.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "duplicate_departments")}>
                                {this.state.focus === "duplicate_departments" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "duplicate_departments" &&
                                <div className="import-list">
                                    {_.map(duplicate_names.departments, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {duplicate_names.locations.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi staðsetningar fundust oftar en einu sinni í
                                kerfinu. Vinsamlegast breyttu nöfnum þeirra í skjalinu í
                                viðeigandi UUID.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "duplicate_locations")}>
                                {this.state.focus === "duplicate_locations" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "duplicate_locations" &&
                                <div className="import-list">
                                    {_.map(duplicate_names.locations, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {duplicate_names.types.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi tegundir fundust oftar en tvisvar í
                                kerfinu. Vinsamlegast breyttu nöfnum þeirra í skjalinu í
                                viðeigandi UUID.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "duplicate_types")}>
                                {this.state.focus === "duplicate_types" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "duplicate_types" &&
                                <div className="import-list">
                                    {_.map(duplicate_names.types, this.mapList)}
                                </div>
                            }
                        </div>
                    }

                    {exists_but_no_access.departments.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Þú hefur ekki nauðsynleg réttindi til að stofna búnað undir
                                eftirfarandi deildum.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "access_departments")}>
                                {this.state.focus === "access_departments" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "access_departments" &&
                                <div className="import-list">
                                    {_.map(exists_but_no_access.departments, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {exists_but_no_access.locations.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Þú hefur ekki nauðsynleg réttindi til að stofna búnað undir
                                eftirfarandi staðsetningum.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "access_locations")}>
                                {this.state.focus === "access_locations" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "access_locations" &&
                                <div className="import-list">
                                    {_.map(exists_but_no_access.locations, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {exists_but_no_access.types.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Þú hefur ekki nauðsynleg réttindi til að stofna búnað af eftirfarandi
                                tegundum.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "access_types")}>
                                {this.state.focus === "access_types" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            {this.state.focus === "access_types" &&
                                <div className="import-list">
                                    {_.map(exists_but_no_access.types, this.mapList)}
                                </div>
                            }
                        </div>
                    }


                    {need_to_create.departments.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi deildir fundust ekki í kerfinu.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "create_departments")}>
                                {this.state.focus === "create_departments" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            <br/>
                            <span>
                                Viltu að deildirnar verði stofnaðar?
                            </span>
                            <Button className="button" disabled>Já</Button>
                            <Button className="button" disabled>Nei</Button>
                            {this.state.focus === "create_departments" &&
                                <div className="import-list">
                                    {_.map(need_to_create.departments, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {need_to_create.locations.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi staðsetningar fundust ekki í kerfinu.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "create_locations")}>
                                {this.state.focus === "create_locations" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            <br/>
                            <span>
                                Viltu að staðsetningarnar verði stofnaðar?
                            </span>
                            <Button className="button" disabled>Já</Button>
                            <Button className="button" disabled>Nei</Button>
                            {this.state.focus === "create_locations" &&
                                <div className="import-list">
                                    {_.map(need_to_create.locations, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    {need_to_create.types.length > 0 &&
                        <div className="warning body">
                            <span className="warning text">
                                Eftirfarandi tegundir fundust ekki í kerfinu.
                            </span>
                            <Button className="button" onClick={this.toggleList.bind(this, "create_types")}>
                                {this.state.focus === "create_types" ? "Fela lista" : "Sjá lista"}
                            </Button>
                            <br/>
                            <span>
                                Viltu að tegundirnar verði stofnaðar?
                            </span>
                            <Button className="button" disabled>Já</Button>
                            <Button className="button" disabled>Nei</Button>
                            {this.state.focus === "create_types" &&
                                <div className="import-list">
                                    {_.map(need_to_create.types, this.mapList)}
                                </div>
                            }
                        </div>
                    }
                    <div>
                        <hr/>
                        <p>Útskýringar á reitum sem þurfa að vera í Exel skjalinu sem hlaðið er inn:</p>
                        <p><strong>name</strong></p>
                        <ul>
                            <li>Nafn á búnaðinum</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>type</strong></p>
                        <ul>
                            <li>Tegund búnaðar</li>
                            <li>Textastrengur</li>
                            <li>Sé tegundin ekki til þarf að <a href="/settings/types">stofna hana í kerfinu</a></li>
                        </ul>
                        <p><strong>department</strong></p>
                        <ul>
                            <li>Deildin sem búnaðurinn á að falla undir</li>
                            <li>Textastrengur</li>
                            <li>Sé deildin ekki til þarf að <a href="/settings/departments">stofna hana í kerfinu</a></li>
                        </ul>
                        <p><strong>location</strong></p>
                        <ul>
                            <li>Nafn á staðsetningu</li>
                            <li>Textastrengur</li>
                            <li>Sé staðsetning ekki til þarf að <a href="/settings/locations">stofna hana í kerfinu</a></li>
                        </ul>
                        <p><strong>description</strong></p>
                        <ul>
                            <li>Lýsing á búnaðinum</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>comment</strong></p>
                        <ul>
                            <li>Athugasemd við búnað</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>status</strong></p>
                        <ul>
                            <li>Staða búnaðar</li>
                            <li>Textastrengur</li>
                            <li>Eitt af eftirfarandi
                                <ul>
                                    <li>in-use</li>
                                    <li>in-storage</li>
                                    <li>for-sale</li>
                                    <li>sold</li>
                                    <li>deleted</li>
                                    <li>disposed</li>
                                    <li>given</li>
                                </ul>
                            </li>
                        </ul>
                        <p><strong>purchase_price</strong></p>
                        <ul>
                            <li>Kaupverð búnaðar</li>
                            <li>Númer</li>
                        </ul>
                        <p><strong>purchase_date</strong></p>
                        <ul>
                            <li>Kaupdagsetning</li>
                            <li>Textastrengur</li>
                            <li>Verður að vera á forminu YYYY-MM-DD (t.d. 2016-02-21)</li>
                        </ul>
                        <p><strong>serial_number</strong></p>
                        <ul>
                            <li>Valkvæmt raðnúmer</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>mac_address</strong></p>
                        <ul>
                            <li>Valkvæmt MAC númer</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>account_key</strong></p>
                        <ul>
                            <li>Valkvæmt bókhaldsnúmer</li>
                            <li>Textastrengur</li>
                        </ul>
                        <p><strong>user</strong></p>
                        <ul>
                            <li>Notendanafn þess sem er með búnaður</li>
                            <li>Textastrengur</li>
                            <li>Notað til skráningar ef búnaður er í persónulegri notkun</li>
                        </ul>
                        <p><strong>home_use</strong></p>
                        <ul>
                            <li>Hvort búnaður er heimabúnaður eða ekki</li>
                            <li>Eitt af eftirfarandi
                                <ul>
                                    <li>true</li>
                                    <li>false</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
});


module.exports = ImportTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Import/ImportTab.react.js